import React from 'react'

import type { Brief } from '@disco/types/types/brief'

import { AccessibleIcon, DropdownMenu, IconButton } from 'components/ds'
import { HoverContext } from 'components/ui/hover-provider'
import { EllipsisVerticalIcon } from 'components/ui/icon/svg-icons'

import BriefMenuBody from './brief-menu-body'
import { useBriefMenu } from './use-brief-menu'

type BriefActionMenuProps = {
  brief: Brief
  onOpenChange?: (open: boolean) => void
  hoverContext?: React.ContextType<typeof HoverContext>
  iconColor?: string
  editMode?: boolean
}

const BriefActionMenu: React.FC<BriefActionMenuProps> = ({
  brief,
  onOpenChange,
  hoverContext,
  iconColor = 'gray',
  editMode,
}) => {
  const { deadlinePickerModal, handleOpenChange, ...menuProps } = useBriefMenu({
    brief,
    editMode,
    hoverContext,
    onOpenChange,
  })

  //TODO: remove briefWorkflowV2Enabled check when V1 is deprecated
  return (
    <>
      <DropdownMenu.Root onOpenChange={handleOpenChange}>
        <DropdownMenu.Trigger>
          <IconButton variant="ghost" size="2">
            <AccessibleIcon label="Brief Actions">
              <EllipsisVerticalIcon size={24} color={iconColor} />
            </AccessibleIcon>
          </IconButton>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content variant="soft" align="end">
          <BriefMenuBody brief={brief} editMode={editMode} {...menuProps} />
        </DropdownMenu.Content>
      </DropdownMenu.Root>
      {deadlinePickerModal}
    </>
  )
}

export default BriefActionMenu
